import axios from "axios";
import {useEffect} from "react";
import {message, Modal} from "antd";

const AxiosConfig = ({ children }) => {
    const [messageApi, contextHolder] = message.useMessage();

    //axios.defaults.baseURL = process.env.REACT_APP_API_URL === undefined ? 'https://dev-work-api.ti-vtb.com' : 'https://' + process.env.REACT_APP_API_URL + '.ti-vtb.com';
    axios.defaults.baseURL = process.env.REACT_APP_API_URL === undefined ? "https://dev-work-api.ti-vtb.com" : "https://" + process.env.REACT_APP_API_URL + ".vcb.amc.seoul.kr";
    axios.defaults.headers['X-AUTH-TOKEN'] = `Bearer ${sessionStorage.getItem('token')}`;

    useEffect(() => {
        const resInterceptor = (response) => {
            return response;
        }

        const errInterceptor = error => {
            const resMessage = error.response?.data?.message;

            const SERVER_ERROR_MESSAGE = 'An unexpected error occurred. Please contact us at int@amc.seoul.kr. [Server error]';

            if (resMessage === SERVER_ERROR_MESSAGE) {
                Modal.error({
                    title: 'error',
                    content: resMessage,
                    centered: true,
                });
            } else if (resMessage) {
                messageApi.error(resMessage).then();
            }
            return Promise.reject(error);
        }

        const interceptor = axios.interceptors.response.use(resInterceptor, errInterceptor);

        return () => axios.interceptors.response.eject(interceptor);
    }, [messageApi]);
    return (
        <>
            {contextHolder}
            {children}
        </>
    );
};

export default AxiosConfig;
